export default {
    baseStyle: {
        body: {
            padding: {base: '24px 16px 8px'}
        },
        title: {
            textStyle: 'webH2'
        },
        description: {
            textStyle: 'bodySmRegular'
        },
        label: {
            textStyle: 'webH3'
        },
        link: {
            display: 'block',
            h: 'auto',
            minH: 'auto',
            textAlign: 'left',
            textStyle: 'bodySmLink'
        },
        radio: {
            alignItems: 'center'
        },
        addressDisplay: {
            textStyle: 'bodySmRegular'
        }
    },
    variants: {
        noCloseMatch: {
            body: {
                padding: {base: '24px 16px'}
            }
        },
        melissaAddressValidationBypass: {
            body: {
                display: 'flex',
                flexDirection: 'column',
                gap: 5,
                width: '100%',
                padding: '24px 16px',
                overflowX: 'hidden'
            },
            callout: {
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                width: '100%'
            },
            calloutTitleRow: {
                alignItems: 'center',
                gap: 2,
                width: '100%'
            },
            warningIcon: {
                boxSize: 5,
                flexShrink: 0
            },
            titleText: {
                fontSize: { base: '12px', lg: '14px' },
                lineHeight: { base: '18px', lg: '20px' },
                textStyle: 'bodySmMedium',
                wordBreak: 'break-word'
            },
            description: {
                fontSize: { base: '12px', lg: '14px' },
                lineHeight: { base: '18px', lg: '20px' },
                textStyle: 'bodySmRegular',
                wordBreak: 'break-word'
            },
            addressSection: {
                width: '100%',
                gap: 3
            },
            labelText: {
                fontSize: { base: '12px', lg: '14px' },
                lineHeight: { base: '16px', lg: '20px' },
                textStyle: 'bodySmBold',
                textTransform: 'uppercase'
            },
            addressDisplay: {
                textStyle: 'bodyXsRegular'
            },
            actions: {
                width: '100%',
                gap: 2,
                paddingTop: 8
            },
            actionButton: {
                width: '100%',
                height: '48px',
                minHeight: '48px'
            }
        },
        poBoxMilitary: {
            body: {
                padding: {base: '24px 16px 14px'}
            }
        },
        geoMismatch: {
            body: {
                padding: {base: '24px 16px 30px'}
            }
        },
        geoMismatchNested: {
            body: {
                padding: 0
            }
        }
    }
}
